import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface EditButtonProps {
    onClick: () => void
    className?: string
}

const EditButton = ({ onClick, className = '' }: EditButtonProps) => {
    return (
        <button type='button' className={`editBtn ${className}`} onClick={onClick}>
            <DynamicFaIcon iconName={'edit'} />
        </button>
    )
}

export default EditButton
